module.exports = "<p>\r\n  classmgmt works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_components/classmgmt.component.html
// module id = ./src/app/_components/classmgmt.component.html
// module chunks = main